import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),

    endpoints: builder => ({
        login: builder.mutation({
            query: formData => ({
                // No trailing slash — live server redirects /login/ → /login and turns POST into GET (405).
                url: '/login',
                method: 'POST',
                body: formData,
            }),
        }),

        logout: builder.mutation({
            query: () => ({
                url: '/logout',
                method: 'POST',

                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            }),
        }),
    }),
});

export const { useLoginMutation, useLogoutMutation } = authApi;
